module.exports = __webpack_public_path__ + "static/media/gamification_3_zh_HK.fbf38b3a.png";